import React from 'react';
import { TagIcon, GraduationCapIcon, AwardIcon, AlertTriangle } from 'lucide-react';
export function DiscountBanner({
  discountSelections,
  onDiscountToggle,
  isGen2Mode = false
}) {
  return <div className={`border-2 rounded-lg p-6 mb-8 shadow-sm transition-all ${isGen2Mode ? 'bg-slate-50 border-slate-300 opacity-60' : 'bg-gradient-to-r from-green-50 to-emerald-50 border-green-200'}`} data-id="element-404">
      <div className="flex items-start mb-4" data-id="element-405">
        <TagIcon size={24} className={`mr-3 flex-shrink-0 mt-1 ${isGen2Mode ? 'text-slate-400' : 'text-green-600'}`} data-id="element-406" />
        <div data-id="element-407">
          <h3 className={`text-lg font-semibold mb-1 ${isGen2Mode ? 'text-slate-500' : 'text-green-800'}`} data-id="element-408">
            Available Discounts
          </h3>
          <p className={`text-sm ${isGen2Mode ? 'text-slate-500' : 'text-green-700'}`} data-id="element-409">
            {isGen2Mode ? 'Discounts are not available for Gen 2 equipment rentals.' : 'Select any applicable discounts. These will be reviewed and applied by our team.'}
          </p>
        </div>
      </div>

      {isGen2Mode && <div className="mb-4 p-3 bg-orange-50 border border-orange-300 rounded-lg" data-id="element-410">
          <div className="flex items-center gap-2" data-id="element-411">
            <AlertTriangle size={16} className="text-orange-600 flex-shrink-0" data-id="element-412" />
            <p className="text-xs text-orange-800 font-medium" data-id="element-413">
              Gen 2 equipment is not eligible for USAT or Collegiate discounts.
              Switch to Gen 3 to access discounts.
            </p>
          </div>
        </div>}

      <div className="space-y-3" data-id="element-414">
        {/* USAT Sanctioned Event Discount */}
        <div className={`rounded-lg p-4 border-2 shadow-sm ${isGen2Mode ? 'bg-slate-100 border-slate-300' : 'bg-white border-green-300'}`} data-id="element-415">
          <div className="flex items-start" data-id="element-416">
            <div className="flex items-center h-5" data-id="element-417">
              <input id="usatSanctioned" type="checkbox" checked={discountSelections.usatSanctioned} onChange={() => onDiscountToggle('usatSanctioned')} disabled={isGen2Mode} className={`h-5 w-5 rounded ${isGen2Mode ? 'border-slate-300 text-slate-400 cursor-not-allowed' : 'border-green-300 text-green-600 focus:ring-green-500'}`} data-id="element-418" />
            </div>
            <div className="ml-3 flex-1" data-id="element-419">
              <label htmlFor="usatSanctioned" className={`font-semibold flex items-center ${isGen2Mode ? 'text-slate-400 cursor-not-allowed' : 'text-green-800 cursor-pointer'}`} data-id="element-420">
                <AwardIcon size={18} className={`mr-2 ${isGen2Mode ? 'text-slate-400' : 'text-green-600'}`} data-id="element-421" />
                USAT Sanctioned Event
                <span className={`ml-2 text-xs font-bold px-2.5 py-1 rounded-full ${isGen2Mode ? 'bg-slate-300 text-slate-500' : 'bg-green-600 text-white'}`} data-id="element-422">
                  15% OFF
                </span>
              </label>
              <p className={`text-sm mt-1 ${isGen2Mode ? 'text-slate-400' : 'text-green-700'}`} data-id="element-423">
                {isGen2Mode ? 'Not available for Gen 2 equipment' : 'For officially sanctioned USA Taekwondo events. Verification required.'}
              </p>
            </div>
          </div>
        </div>

        {/* Collegiate Discount */}
        <div className={`rounded-lg p-4 border ${isGen2Mode ? 'bg-slate-100 border-slate-300' : 'bg-white border-green-200'}`} data-id="element-424">
          <div className="flex items-start" data-id="element-425">
            <div className="flex items-center h-5" data-id="element-426">
              <input id="collegiate" type="checkbox" checked={discountSelections.collegiate} onChange={() => onDiscountToggle('collegiate')} disabled={isGen2Mode} className={`h-5 w-5 rounded ${isGen2Mode ? 'border-slate-300 text-slate-400 cursor-not-allowed' : 'border-green-300 text-green-600 focus:ring-green-500'}`} data-id="element-427" />
            </div>
            <div className="ml-3 flex-1" data-id="element-428">
              <label htmlFor="collegiate" className={`font-medium flex items-center ${isGen2Mode ? 'text-slate-400 cursor-not-allowed' : 'text-green-800 cursor-pointer'}`} data-id="element-429">
                <GraduationCapIcon size={18} className={`mr-2 ${isGen2Mode ? 'text-slate-400' : 'text-green-600'}`} data-id="element-430" />
                Collegiate Discount
                <span className={`ml-2 text-xs font-semibold px-2 py-0.5 rounded ${isGen2Mode ? 'bg-slate-200 text-slate-500' : 'bg-green-100 text-green-800'}`} data-id="element-431">
                  10% OFF
                </span>
              </label>
              <p className={`text-sm mt-1 ${isGen2Mode ? 'text-slate-400' : 'text-green-700'}`} data-id="element-432">
                {isGen2Mode ? 'Not available for Gen 2 equipment' : 'For college and university taekwondo programs'}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className={`mt-4 pt-4 border-t ${isGen2Mode ? 'border-slate-200' : 'border-green-200'}`} data-id="element-433">
        <p className={`text-xs flex items-center ${isGen2Mode ? 'text-slate-400' : 'text-green-700'}`} data-id="element-434">
          <TagIcon size={14} className="mr-1" data-id="element-435" />
          {isGen2Mode ? 'Switch to Gen 3 equipment to access available discounts' : 'Discounts are subject to verification and approval by our team'}
        </p>
      </div>
    </div>;
}